import { GoogleMapsProvider } from 'src/providers/GoogleMapsProvider'

import { MultiPointMap } from 'src/components/molecules/MultiPointMap/MultiPointMap'
import { MultiPointMapGeo } from 'src/components/molecules/MultiPointMap/types'

type ProjectLocationsProps = {
  geoData: Array<MultiPointMapGeo>
}

export const ProjectLocations = ({ geoData }: ProjectLocationsProps) => (
  <div id='planting-locations' className='w-full'>
    <GoogleMapsProvider>
      <div className='w-full h-[400px] lg:h-[576px]'>
        <MultiPointMap
          pinIcon='/img/icons/treeLocationPin.svg'
          geoData={geoData}
          zoom={12}
          constrainMap
          mapProps={{
            mapContainerStyle: {
              width: '100%',
              height: '100%'
            }
          }}
        />
      </div>
    </GoogleMapsProvider>
  </div>
)
